<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/sale/order/detail/pageWithCreateOutOrder" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('kehumingcheng')">
            <el-input :value="customer && customer.customerCodeName" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('xiaoshoudingdanhao')">
            <el-input v-model="yt.conditions.saleOrderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')">
            <yi_data_select type="material2" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('hangzhuangtai')">
            <yi_dictionary_select :multiple="'true'" :max="999"  type="WMS_SALE_ORDER_DETAIL_STATUS" :ids.sync="yt.conditions.statusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(conditions)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import { max } from 'mathjs';

export default {
  name: 'web_wms_delivery_issue_sale_order_line',
  props: {
    customer: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    // 生产配置-产品色号管理
    colorNoEnable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pushLoading: false,
      conditions: {
        wmsCustomerId: this.customer.id,
      },
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          align: 'center',
          selectable: (row, index) => true,
          width: 130
        },
        {
          label: 'xiaoshoudingdanhao',
          prop: 'saleOrderInfo.no'
        },
        {
          label: 'kehumingcheng',
          prop: 'wmsCustomerInfo.name'
        },
        {
          label: 'hanghao',
          prop: 'serialNo'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialInfo.name'
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: this.colorNoEnable
        },
        {
          label: 'guige',
          prop: 'materialInfo.spec'
        },
        {
          label: 'xiaoshoushuliang',
          prop: 'saleQuantity'
        },
        {
          label: 'yixuanshuliang',
          prop: 'selectedQuantity'
        },
        {
          label: 'yichukushuliang',
          prop: 'outQuantity'
        },
        {
          label: 'xiaoshoudanwei',
          prop: 'saleUnit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'danweihuozhi',
          prop: 'price'
        },
        {
          label: 'hangzhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'WMS_SALE_ORDER_DETAIL_STATUS'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.conditions.statusList = ['0','1']
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 勾选行时触发
    selectionChange(rows) {
      this.$emit('input', rows);
    }
  }
};
</script>
